import { render, staticRenderFns } from "./newPageShouhou.vue?vue&type=template&id=31b480a2&scoped=true"
import script from "./newPageShouhou.vue?vue&type=script&lang=js"
export * from "./newPageShouhou.vue?vue&type=script&lang=js"
import style0 from "./newPageShouhou.vue?vue&type=style&index=0&id=31b480a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b480a2",
  null
  
)

export default component.exports